import { SphereButton } from "@components/common/sphere-button";
import { FaroTextButton } from "@components/common/faro-text-button";
import {
  useIsCookieManagerInitialized,
  useShowCookieManager,
} from "@faro-lotv/foreign-observers";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useToast } from "@hooks/use-toast";
import {
  DEFAULT_BOLD_TEXT_FONT_WEIGHT,
  DEFAULT_INPUT_FONT_SIZE,
} from "@styles/common-styles";
import { UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useAppSelector } from "@store/store-helper";
import { isUserLoggedInSelector } from "@store/user/user-selector";

/** Allow user to manage the cookie manager in account settings */
export function AccountCookiesPreferences(): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const { showToast } = useToast();
  const { isScreenSmOrSmaller } = useMediaQueryList();
  const isCookieManagerInitialized = useIsCookieManagerInitialized();
  const showCookieManager = useShowCookieManager();
  const isUserLoggedIn = useAppSelector(isUserLoggedInSelector);

  function showManageCookiesError(): void {
    showToast({
      type: "error",
      message: "Unknown error loading cookie manager.",
      description: "Please reload the page or try again later.",
    });
  }

  function onCookiePreferences(): void {
    trackEvent({
      name: UserProfile.manageCookies,
      props: { isUserLoggedIn },
    });

    // If the cookie manager is not available, show an error message
    if (!isCookieManagerInitialized) {
      showManageCookiesError();
      return;
    }

    try {
      showCookieManager();
    } catch {
      showManageCookiesError();
    }
  }

  if (isScreenSmOrSmaller) {
    return (
      <SphereButton onClick={onCookiePreferences} sx={{ width: "100%" }}>
        Open cookies preferences
      </SphereButton>
    );
  }

  return (
    <FaroTextButton
      onClick={onCookiePreferences}
      sx={{
        fontSize: DEFAULT_INPUT_FONT_SIZE,
        fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT,
      }}
    >
      Open cookies preferences
    </FaroTextButton>
  );
}
